import React, {useState} from 'react';
import { Grid, Input, InputLabel, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import { useDispatch } from 'react-redux';
import { editPax, resetEditPaxStatus } from '../../../store/dcs'
import StatusDisplay from '../../admin/StatusDisplay'

// NOTE // StatusDisplay uses 'loading', 'failure', and 'success', while editStatus (editPaxStatus in dcs store) uses null, false, and true respectively (and '' for not active)
const configureStatus = (pax, editStatus) => {
  let status = editStatus.status

  // NOTE // only show the status if the pax is the one being edited
  if (editStatus.rloc && editStatus.rloc === pax.PNRRefNo && editStatus.paxNum && editStatus.paxNum === pax.PaxNumber) {
    if (status === null) {
      return 'loading'
    }
    else if (status === false) {
      return 'failure'
    }
    else if (status === true) {
      return 'success'
    }
    else {
      return null
    }
  }
  else {
    return null
  }
}

const EditButton = (props) => {
  const { canEdit, handleSave, setCanEdit, resetEditStatus} = props

  if (canEdit) {
    return (
      <IconButton
        aria-label="toggle edit phone"
        style={{paddingRight: '5px', paddingLeft: '5px', paddingTop: '25px', paddingBottom: '15px'}}
        onClick={() => {handleSave()}}
      >
        <SaveIcon />
      </IconButton>
    )
  }
  else {
    return (
      <IconButton
      aria-label="toggle edit phone"
      style={{paddingRight: '5px', paddingLeft: '5px', paddingTop: '25px', paddingBottom: '15px'}}
      onClick={() => {setCanEdit(true); resetEditStatus()}}
    >
      <EditIcon />
    </IconButton>
    )
  }
}

const EditStatusDisplay = (props) =>{
  const {editStatus, pax} = props
  let configuredStatus = configureStatus(pax, editStatus)

  if (configuredStatus !== null) {
    return <StatusDisplay status={configuredStatus} style={{paddingBottom: '65%'}} />
  }
  else {
    return <div></div>
  }
}

export const InlineEdit = (props) => {
  const { pax, initialValue, label, id, onSave, editStatus } = props
  const [canEdit, setCanEdit] = useState(false);
  const [value, setValue] = useState(initialValue || '')
  const dispatch = useDispatch()

  const handleSave = () => {
    let output = onSave(pax, value)
    dispatch(editPax(output))
    setCanEdit(false)
  }

  const resetEditStatus = () => {
    dispatch(resetEditPaxStatus())
  }

  return (
    <Grid container item xs={12} justifyContent="center" alignContent="center">
      <Grid container item xs={9} justifyContent="center" alignContent="center">
        <Grid container item xs={8} justifyContent="center" alignContent="center">
          {/* NOTE // id should be kebab case e.g. "phone-edit" */}
          <InputLabel htmlFor={id} style={{fontWeight: 'bold', color: 'black'}}>{label}</InputLabel>
          <Input
            id={id}
            value={value}
            disabled={!canEdit}
            onChange={(e) => {setValue(e.target.value)}}
          />
        </Grid>
        <Grid item xs={1}>
          <EditButton canEdit={canEdit} handleSave={handleSave} setCanEdit={setCanEdit} resetEditStatus={resetEditStatus} />
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid container alignContent="flex-end" item xs={1}>
          <EditStatusDisplay editStatus={editStatus} pax={pax} />
        </Grid>
      </Grid>
    </Grid>
  )
}